import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AttendanceWatchState {
  userId: number | null
  armed: boolean
  observedOpenAttendanceId: number | null
  resetForLogin: (userId: number, armed: boolean) => void
  ensureUser: (userId: number) => void
  observeOpen: (userId: number, attendanceId: number) => void
  clear: () => void
}

const CLEARED_STATE = {
  userId: null,
  armed: false,
  observedOpenAttendanceId: null,
} as const

export const useAttendanceWatchStore = create<AttendanceWatchState>()(
  persist(
    (set) => ({
      ...CLEARED_STATE,

      resetForLogin: (userId, armed) => {
        set({
          userId,
          armed,
          observedOpenAttendanceId: null,
        })
      },

      ensureUser: (userId) => {
        set((state) => {
          if (state.userId === userId) return state
          return {
            userId,
            armed: false,
            observedOpenAttendanceId: null,
          }
        })
      },

      observeOpen: (userId, attendanceId) => {
        set({
          userId,
          armed: true,
          observedOpenAttendanceId: attendanceId,
        })
      },

      clear: () => set(CLEARED_STATE),
    }),
    {
      name: 'lc-attendance-watch:v1',
      partialize: (state) => ({
        userId: state.userId,
        armed: state.armed,
        observedOpenAttendanceId: state.observedOpenAttendanceId,
      }),
    },
  ),
)
